import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "s-pl-lg s-mr-md" }
const _hoisted_2 = { class: "col title row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["service__item-card row items-center", { 'service__item-card--mobile': _ctx.isMobile }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_skeleton, {
        type: "QToggle",
        width: "60px",
        height: "60px",
        animation: "fade"
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_skeleton, {
        class: _normalizeClass(["s-skeleton s-mb-sm", `col-xs-11`]),
        type: "QBadge",
        animation: "fade"
      }),
      _createVNode(_component_q_skeleton, {
        class: _normalizeClass(["s-skeleton", `col-xs-8`]),
        type: "QBadge",
        animation: "fade"
      })
    ])
  ], 2))
}